import { id } from "@volkswagen-onehub/gfa-locale-service";
export function defineLocaleService(config) {
    return {
        id: "locale-service",
        create: () => ({
            "1.2.0": () => ({ featureService: config })
        })
    };
}
export function defineGfaLocalService() {
    return {
        id,
        dependencies: {
            featureServices: {
                "locale-service": "^1.2.0"
            }
        },
        create: env => {
            const localeService = env.featureServices["locale-service"];
            return {
                "1.0.0": () => ({
                    featureService: localeService
                })
            };
        }
    };
}
export const defineLocaleServices = (config) => [
    defineGfaLocalService(),
    defineLocaleService(config)
];
